import { Stack, Typography, useTheme } from "@mui/material";
import { ChevronRight, type LucideIcon } from "lucide-react";
import type { FC } from "react";
import type { CalloutColor } from "web_myplann/Shared/Components/Callout";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

type Props = {
	color: CalloutColor;
	icon: LucideIcon;
	title: string;
	description: string;
	showChevron: boolean;
};

export const CalloutContent: FC<Props> = ({
	color,
	icon: Icon,
	title,
	description,
	showChevron,
}) => {
	const { palette, iconSize } = useTheme();
	const tint = palette[color];

	return (
		<Stack direction="row" alignItems="flex-start" gap={1.2} width="100%">
			<IconBox bg={tint[100]} size={32}>
				<Icon size={iconSize.sm} color={tint.main} />
			</IconBox>
			<Stack flex={1} minWidth={0} gap={0.2}>
				<Typography variant="bodyStrong">{title}</Typography>
				<Typography variant="hint" color={palette.grey[600]} lineHeight={1.625}>
					{description}
				</Typography>
			</Stack>
			{showChevron && <ChevronRight size={iconSize.md} color={tint.main} />}
		</Stack>
	);
};
